// Mock data for BabyCenter Vietnam Clone

export const pregnancyWeeks = [
  {
    week: 4,
    title: "Tuần 4: Thai nhi bắt đầu phát triển",
    description: "Thai nhi của bạn có kích thước bằng hạt tiêu. Các cơ quan chính bắt đầu hình thành.",
    size: "Hạt tiêu",
    image: "https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?w=800",
    advice: [
      "Uống vitamin trước sinh hàng ngày",
      "Tránh rượu và thuốc lá",
      "Nghỉ ngơi đầy đủ",
      "Ăn thực phẩm giàu axit folic"
    ],
    symptoms: ["Buồn nôn nhẹ", "Mệt mỏi", "Nhạy cảm với mùi hương"]
  },
  {
    week: 8,
    title: "Tuần 8: Thai nhi đang phát triển nhanh",
    description: "Thai nhi có kích thước bằng quả việt quất. Các ngón tay chân bắt đầu hình thành.",
    size: "Quả việt quất",
    image: "https://images.unsplash.com/photo-1457342813143-a1ae27448a82?w=800",
    advice: [
      "Khám thai định kỳ",
      "Uống nhiều nước",
      "Tập thể dục nhẹ nhàng",
      "Tránh thực phẩm sống"
    ],
    symptoms: ["Buồn nôn buổi sáng", "Thèm ăn", "Thay đổi tâm trạng"]
  },
  {
    week: 12,
    title: "Tuần 12: Kết thúc tam cá nguyệt đầu",
    description: "Thai nhi có kích thước bằng quả mơ. Hầu hết các cơ quan đã hình thành.",
    size: "Quả mơ",
    image: "https://images.unsplash.com/photo-1583710457367-47de0ea21fef?w=800",
    advice: [
      "Siêu âm thai nhi",
      "Bắt đầu mua đồ cho bé",
      "Tham gia lớp học tiền sản",
      "Giữ tâm trạng thoải mái"
    ],
    symptoms: ["Giảm buồn nôn", "Tăng năng lượng", "Bụng bắt đầu lớn"]
  },
  {
    week: 16,
    title: "Tuần 16: Cảm nhận được cử động",
    description: "Thai nhi có kích thước bằng quả bơ. Bạn có thể bắt đầu cảm nhận cử động của bé.",
    size: "Quả bơ",
    image: "https://images.unsplash.com/photo-1582486225644-aeacf6aa0b1b?w=800",
    advice: [
      "Theo dõi cử động thai nhi",
      "Ăn thực phẩm giàu canxi",
      "Massage nhẹ nhàng",
      "Ngủ nghiêng bên trái"
    ],
    symptoms: ["Cảm nhận cử động", "Đau lưng nhẹ", "Tăng cân"]
  },
  {
    week: 20,
    title: "Tuần 20: Giữa chặng đường",
    description: "Thai nhi có kích thước bằng quả chuối. Các giác quan phát triển mạnh.",
    size: "Quả chuối",
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=800",
    advice: [
      "Siêu âm hình thái học",
      "Nói chuyện với bé",
      "Tập yoga cho bà bầu",
      "Chuẩn bị phòng cho bé"
    ],
    symptoms: ["Cử động mạnh hơn", "Đau chân", "Khó ngủ"]
  },
  {
    week: 24,
    title: "Tuần 24: Phát triển não bộ",
    description: "Thai nhi có kích thước bằng quả bắp ngô. Não bộ phát triển nhanh chóng.",
    size: "Quả bắp ngô",
    image: "https://images.unsplash.com/photo-1542037104857-ffbb0b9155fb?w=800",
    advice: [
      "Kiểm tra đường huyết",
      "Nghe nhạc cho bé",
      "Tập thở khi chuyển dạ",
      "Bổ sung sắt"
    ],
    symptoms: ["Thai động rõ ràng", "Dễ mệt", "Phù nhẹ"]
  },
  {
    week: 28,
    title: "Tuần 28: Tam cá nguyệt cuối",
    description: "Thai nhi có kích thước bằng quả dừa. Bé có thể mở mắt.",
    size: "Quả dừa",
    image: "https://images.unsplash.com/photo-1457342813143-a1ae27448a82?w=800",
    advice: [
      "Khám thai thường xuyên hơn",
      "Chuẩn bị đồ đi sinh",
      "Tìm hiểu về sinh nở",
      "Nghỉ ngơi nhiều hơn"
    ],
    symptoms: ["Khó thở", "Ợ nóng", "Co giật chân"]
  },
  {
    week: 32,
    title: "Tuần 32: Chuẩn bị chào đời",
    description: "Thai nhi có kích thước bằng quả dưa hấu nhỏ. Phổi gần như hoàn thiện.",
    size: "Quả dưa hấu nhỏ",
    image: "https://images.unsplash.com/photo-1583710457367-47de0ea21fef?w=800",
    advice: [
      "Lên kế hoạch sinh nở",
      "Tham quan bệnh viện",
      "Chuẩn bị túi đi sinh",
      "Học kỹ thuật thở"
    ],
    symptoms: ["Khó ngủ", "Đi tiểu thường xuyên", "Co thắt giả"]
  },
  {
    week: 36,
    title: "Tuần 36: Sắp gặp bé rồi",
    description: "Thai nhi có kích thước bằng quả dưa hấu. Bé đã nằm ở tư thế sinh.",
    size: "Quả dưa hấu",
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=800",
    advice: [
      "Theo dõi thai động",
      "Chuẩn bị tinh thần",
      "Hoàn thiện đồ cho bé",
      "Nghỉ ngơi đầy đủ"
    ],
    symptoms: ["Áp lực vùng chậu", "Co thắt thường xuyên", "Mệt mỏi"]
  },
  {
    week: 40,
    title: "Tuần 40: Đến ngày dự sinh",
    description: "Thai nhi đã sẵn sàng chào đời. Trọng lượng trung bình 3-3.5kg.",
    size: "Quả bí ngô nhỏ",
    image: "https://images.unsplash.com/photo-1582486225644-aeacf6aa0b1b?w=800",
    advice: [
      "Nhận biết dấu hiệu chuyển dạ",
      "Giữ liên lạc với bác sĩ",
      "Ăn nhẹ và nghỉ ngơi",
      "Chuẩn bị đến bệnh viện"
    ],
    symptoms: ["Co thắt đều đặn", "Vỡ ối", "Đau lưng dưới"]
  }
];

export const communityPosts = [
  {
    id: 1,
    author: "Minh Anh",
    avatar: "https://ui-avatars.com/api/?name=Minh+Anh&background=ec4899&color=fff",
    week: 24,
    title: "Mang thai tuần 24, bé đạp rất mạnh!",
    content: "Các mẹ ơi, tuần này con bé đạp mạnh lắm, đặc biệt là buổi tối. Có mẹ nào cùng tuần như mình không?",
    likes: 45,
    comments: 12,
    time: "2 giờ trước",
    category: "Tam cá nguyệt 2"
  },
  {
    id: 2,
    author: "Thanh Hương",
    avatar: "https://ui-avatars.com/api/?name=Thanh+Huong&background=ec4899&color=fff",
    week: 16,
    title: "Món ăn giúp giảm buồn nôn",
    content: "Mình muốn chia sẻ một số món ăn giúp mình giảm buồn nôn hiệu quả: gừng chanh mật ong, cháo thịt bằm...",
    likes: 89,
    comments: 34,
    time: "5 giờ trước",
    category: "Dinh dưỡng"
  },
  {
    id: 3,
    author: "Phương Thảo",
    avatar: "https://ui-avatars.com/api/?name=Phuong+Thao&background=ec4899&color=fff",
    week: 32,
    title: "Chuẩn bị đồ đi sinh ở đâu tốt?",
    content: "Các mẹ cho mình xin kinh nghiệm chuẩn bị đồ đi sinh với. Mình đang băn khoăn không biết nên mua ở đâu.",
    likes: 67,
    comments: 28,
    time: "1 ngày trước",
    category: "Chuẩn bị sinh"
  },
  {
    id: 4,
    author: "Lan Phương",
    avatar: "https://ui-avatars.com/api/?name=Lan+Phuong&background=ec4899&color=fff",
    week: 8,
    title: "Lần đầu đi khám thai",
    content: "Hôm nay mình đi khám thai lần đầu, được xem tim con đập, hạnh phúc quá! Các mẹ có kinh nghiệm gì cho lần khám tiếp theo không?",
    likes: 123,
    comments: 45,
    time: "2 ngày trước",
    category: "Tam cá nguyệt 1"
  }
];

export const appointments = [
  {
    id: 1,
    date: "2025-01-15",
    time: "09:00",
    type: "Khám thai định kỳ",
    doctor: "BS. Nguyễn Thị Mai",
    location: "Phòng khám Sản Phụ Khoa - Quận 1",
    status: "confirmed"
  },
  {
    id: 2,
    date: "2026-01-20",
    time: "14:00",
    type: "Siêu âm 4D",
    doctor: "BS. Trần Văn Hùng",
    location: "Trung tâm Siêu âm Thai nhi",
    status: "pending"
  }
];

export const faqData = [
  {
    category: "Dinh dưỡng",
    question: "Bà bầu nên ăn gì?",
    answer: "Bà bầu nên ăn đa dạng các nhóm thực phẩm: rau xanh, trái cây, protein (thịt, cá, trứng), sữa và các chế phẩm từ sữa, ngũ cốc nguyên hạt. Tránh thực phẩm sống, rượu bia, và hạn chế caffeine."
  },
  {
    category: "Dinh dưỡng",
    question: "Bà bầu có nên uống vitamin không?",
    answer: "Có, bà bầu nên uống vitamin trước sinh theo chỉ định của bác sĩ. Đặc biệt là axit folic trong 3 tháng đầu, canxi, sắt và DHA."
  },
  {
    category: "Sức khỏe",
    question: "Bà bầu có được tập thể dục không?",
    answer: "Có, bà bầu nên tập thể dục nhẹ nhàng như đi bộ, yoga, bơi lội. Tránh các môn thể thao mạnh, có nguy cơ va chạm. Nên tham khảo ý kiến bác sĩ trước khi bắt đầu."
  },
  {
    category: "Sức khỏe",
    question: "Làm thế nào để giảm buồn nôn?",
    answer: "Ăn nhiều bữa nhỏ trong ngày, uống trà gừng, ăn bánh quy khô trước khi ngủ dậy, tránh mùi hương nồng. Nếu buồn nôn nhiều, cần gặp bác sĩ."
  },
  {
    category: "Thai nhi",
    question: "Khi nào cảm nhận được thai động?",
    answer: "Thường từ tuần 16-25, mẹ bầu lần đầu có thể cảm nhận muộn hơn. Thai động ban đầu giống như bướm bay trong bụng."
  },
  {
    category: "Thai nhi",
    question: "Nên theo dõi thai động như thế nào?",
    answer: "Từ tuần 28, nên đếm thai động mỗi ngày. Bình thường bé có ít nhất 10 cử động trong 2 giờ. Nếu thai động giảm đột ngột, cần gặp bác sĩ ngay."
  },
  {
    category: "Sinh nở",
    question: "Dấu hiệu chuyển dạ là gì?",
    answer: "Co thắt tử cung đều đặn và tăng dần cường độ, vỡ ối, ra dịch nhầy có máu, đau lưng dưới lan xuống chân. Khi có dấu hiệu này cần đến bệnh viện."
  },
  {
    category: "Sinh nở",
    question: "Sinh thường hay sinh mổ tốt hơn?",
    answer: "Mỗi phương pháp có ưu nhược điểm riêng. Sinh thường phục hồi nhanh hơn, sinh mổ an toàn trong một số trường hợp đặc biệt. Bác sĩ sẽ tư vấn phương pháp phù hợp nhất."
  }
];

export const notifications = [
  {
    id: 1,
    title: "Nhắc nhở khám thai",
    message: "Bạn có lịch khám thai vào ngày mai lúc 9:00 AM với BS. Nguyễn Thị Mai",
    time: "2025-01-14 10:00",
    read: false,
    type: "appointment"
  },
  {
    id: 2,
    title: "Tuần thai mới - Tuần 25",
    message: "Chúc mừng! Bạn đã bước sang tuần 25. Thai nhi có kích thước bằng quả mít nhỏ.",
    time: "2025-01-13 08:00",
    read: false,
    type: "week"
  },
  {
    id: 3,
    title: "Lời khuyên hôm nay",
    message: "Hãy uống đủ 2-3 lít nước mỗi ngày để cơ thể được hydrat hóa tốt.",
    time: "2025-01-12 09:00",
    read: true,
    type: "advice"
  }
];

export const userProfile = {
  name: "Nguyễn Thu Hương",
  email: "thuhungnguyen@example.com",
  avatar: "https://ui-avatars.com/api/?name=Thu+Huong&background=ec4899&color=fff&size=200",
  dueDate: "2025-06-15",
  currentWeek: 24,
  joinDate: "2023-10-01",
  posts: 12,
  comments: 45
};

// Homepage (logged-in): bài viết Thai kỳ
export const pregnancyArticles = [
  {
    id: 1,
    title: "10 tuần thai",
    image: "https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?w=400",
    reviewer: "BS. Lê Minh Anh, Sản phụ khoa"
  },
  {
    id: 2,
    title: "Tam cá nguyệt đầu: Những điều mẹ cần biết",
    image: "https://images.unsplash.com/photo-1457342813143-a1ae27448a82?w=400",
    reviewer: "BS. Nguyễn Thu Hương, Sản phụ khoa"
  },
  {
    id: 3,
    title: "Những điều không nên bỏ qua về rạn da",
    image: "https://images.unsplash.com/photo-1583710457367-47de0ea21fef?w=400",
    reviewer: "BS. Trần Thị Mai, Da liễu"
  },
  {
    id: 4,
    title: "Nghẹt mũi khi mang thai? Có thể là do...",
    image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=400",
    reviewer: "BS. Phạm Văn Hùng, Tai mũi họng"
  },
  {
    id: 5,
    title: "Vỡ ối là gì? Những điều mẹ cần biết",
    image: "https://images.unsplash.com/photo-1542037104857-ffbb0b9155fb?w=400",
    reviewer: "BS. Lê Minh Anh, Sản phụ khoa"
  }
];

// Homepage: Hội đồng tư vấn y khoa
export const medicalAdvisors = [
  { id: 1, name: "BS. Lê Minh Anh", specialty: "Sản phụ khoa", avatar: "https://ui-avatars.com/api/?name=Le+Minh+Anh&background=ec4899&color=fff" },
  { id: 2, name: "BS. Nguyễn Thu Hương", specialty: "Sản phụ khoa", avatar: "https://ui-avatars.com/api/?name=Thu+Huong&background=ec4899&color=fff" },
  { id: 3, name: "BS. Trần Thị Mai", specialty: "Nhi khoa", avatar: "https://ui-avatars.com/api/?name=Tran+Thi+Mai&background=ec4899&color=fff" },
  { id: 4, name: "BS. Phạm Văn Hùng", specialty: "Sản phụ khoa", avatar: "https://ui-avatars.com/api/?name=Pham+Van+Hung&background=ec4899&color=fff" },
  { id: 5, name: "BS. Hoàng Thị Lan", specialty: "Dinh dưỡng", avatar: "https://ui-avatars.com/api/?name=Hoang+Thi+Lan&background=ec4899&color=fff" },
  { id: 6, name: "BS. Đỗ Minh Tuấn", specialty: "Tâm lý", avatar: "https://ui-avatars.com/api/?name=Do+Minh+Tuan&background=ec4899&color=fff" }
];

// Homepage: Khóa học
export const homepageCourses = [
  {
    id: 1,
    title: "CPR, sơ cứu nghẹt thở cho trẻ sơ sinh",
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=400",
    link: "/courses/infant-cpr"
  },
  {
    id: 2,
    title: "Giấc ngủ bé 101",
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400",
    link: "/courses/baby-sleep"
  },
  {
    id: 3,
    title: "Đạt mốc phát triển qua vui chơi",
    image: "https://images.unsplash.com/photo-1587616211892-f7f4bf6f9b44?w=400",
    link: "/courses/milestones"
  }
];

// Shopping: sản phẩm mẹ & bé (fallback khi API chưa chạy)
export const mockProducts = [
  { id: 1, name: 'Vitamin tổng hợp cho bà bầu', price: 285000, category: 'vitamin', image: 'https://images.unsplash.com/photo-1550572017-edd951aa2f1d?w=400', forPregMonthFrom: 1, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 2, name: 'Gối ôm bà bầu chữ U', price: 450000, category: 'sleep', image: 'https://images.unsplash.com/photo-1522771930-78848d9293e8?w=400', forPregMonthFrom: 4, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 3, name: 'Đai đỡ bụng bầu', price: 189000, category: 'support', image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?w=400', forPregMonthFrom: 5, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 4, name: 'Kem chống rạn da bà bầu', price: 320000, category: 'skincare', image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400', forPregMonthFrom: 1, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 5, name: 'Sữa bột công thức 1 (0–6 tháng)', price: 520000, category: 'milk', image: 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=400', forPregMonthFrom: null, forPregMonthTo: null, forBabyMonthFrom: 0, forBabyMonthTo: 6 },
  { id: 6, name: 'Axit folic 400mcg', price: 95000, category: 'vitamin', image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400', forPregMonthFrom: 1, forPregMonthTo: 3, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 7, name: 'Gối chặn lưng cho bà bầu', price: 165000, category: 'sleep', image: 'https://images.unsplash.com/photo-1522771930-78848d9293e8?w=400', forPregMonthFrom: 2, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 8, name: 'Sữa dưỡng thể cho bà bầu', price: 198000, category: 'skincare', image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400', forPregMonthFrom: 1, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
  { id: 9, name: 'Sữa bột công thức 2 (6–12 tháng)', price: 485000, category: 'milk', image: 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=400', forPregMonthFrom: null, forPregMonthTo: null, forBabyMonthFrom: 6, forBabyMonthTo: 12 },
  { id: 10, name: 'Canxi + D3 cho bà bầu', price: 156000, category: 'vitamin', image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400', forPregMonthFrom: 4, forPregMonthTo: 9, forBabyMonthFrom: null, forBabyMonthTo: null },
];